import InputSwitch from "primevue/inputswitch";
import Button from "primevue/button";
import Badge from "primevue/badge";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Avatar from "primevue/avatar";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Card from "primevue/card";
import AutoComplete from "primevue/autocomplete";
import Icon from "./components/Icon.vue";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import Textarea from "primevue/textarea";
import SelectButton from "primevue/selectbutton";
import TreeTable from "primevue/treetable";
import ProgressSpinner from "primevue/progressspinner";
import Message from "primevue/message";
import ProgressBar from "primevue/progressbar";
import Slider from "primevue/slider";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmPopup from "primevue/confirmpopup";
import Toolbar from "./components/Dashboard/DashboardTopMenu.vue";
// import SimpleCard from "./components/SimpleCard.vue";
import Tag from "primevue/tag";
import OverlayPanel from "primevue/overlaypanel";
import Menu from "primevue/menu";
import TabMenu from "primevue/tabmenu";
import Tooltip from "primevue/tooltip";
import Paginator from "primevue/paginator";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Chart from "primevue/chart";
import Password from "primevue/password";
import Breadcrumb from "primevue/breadcrumb";
import Skeleton from "primevue/skeleton";
import CustomBreadcrumb from "@/components/custom-breadcrumb/CustomBreadcrumb.vue";
import Chip from "primevue/chip";
import MultiSelect from "primevue/multiselect";
import Steps from "primevue/steps";

import TemplateTable from "./components/TTable/TemplateTable.vue";

import TForm from "./components/TForm/TForm.vue";
import FilesSearch from "./components/FilesSearch.vue";
import CustomModal from "@/components/CustomModal.vue";
import Listbox from "primevue/listbox";
import SuccessAndFail from "./components/modal/SuccessAndFail.vue";
import ModalForm from "./components/modal/ModalForm.vue";
import CustomCalendar from "./components/custom-calendar/CustomCalendar.vue";
import CustomTooltip from "./components/CustomTooltip.vue";
import BlockUI from "primevue/blockui";

export default {
  load: (Vue) => {
    Vue.component("Tag", Tag);
    Vue.component("InputSwitch", InputSwitch);
    Vue.component("Button", Button);
    Vue.component("Badge", Badge);
    Vue.component("Dialog", Dialog);
    Vue.component("InputText", InputText);
    Vue.component("InputNumber", InputNumber);
    Vue.component("Avatar", Avatar);
    Vue.component("DataTable", DataTable);
    Vue.component("Column", Column);
    Vue.component("Card", Card);
    Vue.component("AutoComplete", AutoComplete);
    Vue.component("Icon", Icon);
    Vue.component("Dropdown", Dropdown);
    Vue.component("Calendar", Calendar);
    Vue.component("Checkbox", Checkbox);
    Vue.component("Textarea", Textarea);
    Vue.component("SelectButton", SelectButton);
    Vue.component("MultiSelect", MultiSelect);
    Vue.component("Password", Password);
    Vue.component("TreeTable", TreeTable);
    Vue.component("ProgressSpinner", ProgressSpinner);
    Vue.component("Message", Message);
    Vue.component("ProgressBar", ProgressBar);
    Vue.component("Slider", Slider);

    Vue.use(ConfirmationService);
    Vue.component("ConfirmPopup", ConfirmPopup);

    Vue.component("Toolbar", Toolbar);
    // Vue.component("SimpleCard", SimpleCard);
    Vue.component("OverlayPanel", OverlayPanel);
    Vue.component("Menu", Menu);
    Vue.component("TabMenu", TabMenu);
    Vue.component("Paginator", Paginator);
    Vue.component("TabView", TabView);
    Vue.component("TabPanel", TabPanel);
    Vue.directive("tooltip", Tooltip);
    Vue.directive("Chart", Chart);
    Vue.component("TemplateTable", TemplateTable);
    Vue.component("TForm", TForm);
    Vue.component("SuccessAndFail", SuccessAndFail);
    Vue.component("ModalForm", ModalForm);
    Vue.component("FilesSearch", FilesSearch);
    Vue.component("CustomTooltip", CustomTooltip);
    Vue.component("CustomModal", CustomModal);
    Vue.component("Listbox", Listbox);
    Vue.component("BlockUI", BlockUI);
    Vue.component("Breadcrumb", Breadcrumb);
    Vue.component("CustomBreadcrumb", CustomBreadcrumb);
    Vue.component("Skeleton", Skeleton);
    Vue.component("Chip", Chip);
    Vue.component("Steps", Steps);
  },
};
